import { IObjectConfig } from '../../../vendor_core/core/src/baseConfigs/layoutConfigShema';
import { ConfigurationTypes } from '../../../vendor_core/core/src/const/ConfigurationTypes';
import ConfigManager from '../../../vendor_core/core/src/managers/ConfigManager';
import ISymbolSpineAnimConfig from '../../../vendor_core/core/src/managers/contracts/configurations/ISymbolSpineAnimConfig';
import GameLoader from '../../../vendor_core/core/src/utils/GameLoader';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import ReelSymbol from "../../../vendor_core/core/src/views/Symbol";
import SymbolSpineAnimation from '../../../vendor_core/core/src/views/SymbolSpineAnimation';

/**
 * Abstraction for a single symbol.
 * A reel contains several of those.
 */
export default class BBReelSymbol extends ReelSymbol {

    public spineAnim: SymbolSpineAnimation = null;

    constructor() {
        super();
    }

    create(
        symBounds: IObjectConfig,
        positionDefinitions: Map<string, IObjectConfig>
    ) {
        this.bounds = symBounds;
        this.positionDefinitions = positionDefinitions;
        this.createSpineAnim();
    }
    /**
     * Play symbol spine animation
     * @public
     * @param animState: default get value from config (if set playDefault: true and defaultState: <some state>, in config),
     *  or state or chaining state for current animation witch is defined in-game config
     * @param loop: default is get value from config
     * @param timeScale: default is get value from config (if set in config) or set to original speed (1)
     * @returns void
     */
    public playSpineAnim = (animName?: string, loop?: boolean, timeScale?: number) => {
        this.spineAnim.setActiveSkin(this.id)
        if (this.id === 0 || this.id === 7) {
            if (animName !== undefined) {
                animName = `star_${animName}`;
            } else {
                animName = `star_idle`;
            }
        }
        if (animName) {
            if (this.spineAnim.state.hasAnimation(animName)) {
                this.spineAnim.play(animName, loop, timeScale);
                this.showActiveAnim();
            } else if (this.spineAnim.hasChainingAnim(animName)) {
                this.spineAnim.playChainingStates(animName, timeScale, loop);
                this.showActiveAnim();
            } else {
                this.show()
                console.warn(
                    `[SPINE ANIMATION] -> Spine <${this.spineAnim.name}> animation <${animName}> is missing from states: <${this.spineAnim.animConfig.states}> or chaining states <${this.spineAnim.animConfig.getSkinConfig(this.spineAnim.activeSkin).chainingStates}> animation! `,
                );
            }
        } else {
            this.defaultPlaySpineAnim()
        }
    }
    public playAsyncSpineAnim = (animName: string, timeScale?: number): Promise<boolean> => {
        return new Promise<boolean>((res) => {
            this.spineAnim.setActiveSkin(this.id)
            if (this.id === 0 || this.id === 7) {
                if (animName !== undefined) {
                    animName = `star_${animName}`;
                } else {
                    animName = `star_idle`;
                }
            }
            if (animName) {
                if (this.spineAnim.state.hasAnimation(animName)) {
                    this.spineAnim.playAsync(animName, timeScale).then(() => {
                        res()
                    }
                    );
                    this.showActiveAnim();
                } else if (this.spineAnim.hasChainingAnim(animName)) {
                    this.spineAnim.playAsyncChainingStates(animName, timeScale).then(() => {
                        res()
                    }
                    );
                    this.showActiveAnim();
                } else {
                    this.show()
                    console.warn(
                        `[SPINE ANIMATION] -> Spine <${this.spineAnim.name}> animation <${animName}> is missing from states: <${this.spineAnim.animConfig.states}> or chaining states <${this.spineAnim.animConfig.getSkinConfig(this.spineAnim.activeSkin).chainingStates}> animation! `,
                    );
                    res()
                }
            }
        })
    }

    protected defaultPlaySpineAnim = () => {
        this.spineAnim.setActiveSkin(this.id)
        let hasPlayDefault = this.spineAnim.animConfig.getSkinConfig(this.spineAnim.activeSkin).playDefault;
        if (hasPlayDefault) {
            this.spineAnim.play();
            this.showActiveAnim();
        }
    }
    protected createSpineAnim = (): void => {
        let config = (ConfigManager.getConfig((ConfigurationTypes.SYMBOL_SPINE_ANIMATIONS)) as ISymbolSpineAnimConfig);
        let anim = new SymbolSpineAnimation(GameLoader.loader.resources[`spine~${config.name}~json`].spineData, config.name, config);
        anim.scale.set(Layout.globalScale);
        this.spineAnim = anim;
        this.addChild(anim);
    }
    public hideActiveAnim = () => {
        this.spineAnim.hide()
    }
    public showActiveAnim = () => {
        this.spineAnim.show()
    }
    public removeSpineAnim = (showSym = true) => {
        if (this.spineAnim) {
            if (showSym) {
                this.show()
            }
            this.removeChild(this.spineAnim);
            this.spineAnim.stop();
            this.spineAnim.destroy();
            this.spineAnim = null;
        }
    }
    public setId(id: number) {
        this.id = id;
    }
}
